var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1464_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.299 15.7807C29.299 14.5516 29.1993 13.6547 28.9834 12.7246H14.9485V18.2721H23.1867C23.0207 19.6507 22.1238 21.7269 20.1306 23.122L20.1026 23.3077L24.5402 26.7455L24.8477 26.7762C27.6712 24.1685 29.299 20.3317 29.299 15.7807Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9485 30.3968C18.9845 30.3968 22.3728 29.068 24.8477 26.7759L20.1306 23.1218C18.8683 24.0021 17.1741 24.6166 14.9485 24.6166C10.9955 24.6166 7.6404 22.009 6.44441 18.4048L6.2691 18.4197L1.65483 21.9907L1.59448 22.1584C4.05265 27.0416 9.10192 30.3968 14.9485 30.3968Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44439 18.405C6.12882 17.4749 5.94618 16.4782 5.94618 15.4485C5.94618 14.4187 6.12882 13.4221 6.42779 12.492L6.41943 12.2939L1.74733 8.66553L1.59447 8.73824C0.581336 10.7646 0 13.0401 0 15.4485C0 17.8569 0.581336 20.1323 1.59447 22.1587L6.44439 18.405Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9485 6.28004C17.7554 6.28004 19.6489 7.49252 20.7285 8.50576L24.9473 4.3866C22.3563 1.97824 18.9845 0.5 14.9485 0.5C9.10192 0.5 4.05265 3.85508 1.59448 8.73821L6.4278 12.492C7.6404 8.88775 10.9955 6.28004 14.9485 6.28004Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1464_262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.313,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1220a261c270ceaca056e000fec80d69.svg";
export { ForwardRef as ReactComponent };